import { NavLink } from "react-router-dom";
import { useLocale } from "../../../intl";
import { casamapaAdminPortalPath } from "../../../constants/casamapaAdminPortalPaths";

const SECTIONS = [
  { segment: "website", key: "website" },
  { segment: "market", key: "market" },
  { segment: "valuation", key: "valuation" },
  { segment: "investment", key: "investment" },
];

export default function CasaMapaAdminAnalyticsSubnav({ basePath }) {
  const { t } = useLocale();
  const base = basePath || casamapaAdminPortalPath("analytics");

  return (
    <nav className="cm-admin-analytics__subnav" aria-label={t("realEstate.casaMapa.admin.analytics.subnavAria")}>
      {SECTIONS.map((section) => (
        <NavLink
          key={section.segment}
          to={`${base}/${section.segment}`}
          className={({ isActive }) =>
            `cm-admin-analytics__subnav-tab${isActive ? " cm-admin-analytics__subnav-tab--active" : ""}`
          }
        >
          {t(`realEstate.casaMapa.admin.analytics.sections.${section.key}`)}
        </NavLink>
      ))}
    </nav>
  );
}
